import { createContext } from 'react';
import { User, LoginCredentials, RegisterData, VerificationData } from '../types';

interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (credentials: LoginCredentials) => Promise<void>;
  register: (data: RegisterData) => Promise<{ message: string }>;
  verifyEmail: (data: VerificationData) => Promise<void>;
  logout: () => Promise<void>;
  resendVerificationCode: (email: string) => Promise<{ message: string }>;
  forgotPassword: (email: string) => Promise<{ message: string }>;
  resetPassword: (token: string, password: string, passwordConfirmation: string) => Promise<{ message: string }>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
